export const mapping: Record<string, string> = {
  id: 'd=>d.Id',
  name: 'd=>d.Name',
  address: 'd=>d.Address',
}

const mapSortTSCanParam = (key: string) => mapping[key]

export default mapSortTSCanParam
